import { InternalServerError } from './errors';
import {
  HttpApiEndpoint,
  HttpApiGroup,
  HttpApiSchema,
  OpenApi,
} from 'effect/unstable/httpapi';

/**
 * Relay for the `sign_in_with_apple` Flutter plugin on Android.
 *
 * Apple posts its `form_post` callback here; the handler reshapes the body
 * into the `intent://` URL the plugin's callback Activity expects and
 * responds 303. iOS uses the native Apple SDK and does not touch this route.
 *
 * Contract: https://pub.dev/packages/sign_in_with_apple/versions/7.0.1 — Android section.
 */
const mobileAppleCallbackEndpoint = HttpApiEndpoint.post(
  'MobileAppleCallback',
  '/apple-callback',
  {
    success: HttpApiSchema.Empty(303),
    error: InternalServerError,
  },
)

  .annotate(OpenApi.Summary, 'Android Apple Sign-In relay')
  .annotate(
    OpenApi.Description,
    "Receives Apple's form_post callback for Android and redirects (303) to an intent:// URL that the sign_in_with_apple Flutter plugin's callback Activity listens for. Package ID in the intent URL switches on deploy mode: production maps to io.listening.main, all other modes map to io.listening.main.dev. No auth — the payload is already authenticated by Apple.",
  );

export const mobileAuthGroup = HttpApiGroup.make('MobileAuth')
  .add(mobileAppleCallbackEndpoint)
  .prefix('/mobile-auth');
